import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import laborActions from "../../../../_actions/laborActions";
import _ from "lodash";

class VerifyLaborModal extends Component {
  state = {
    verifyAs: true,
    mergeWith: false,
    verifyAsFirstName: "",
    verifyAsMi: "",
    verifyAsLastName: "",
    mergeWithLabor: null,
    mergeWithLaborOptions: [],
    verifiedByUserId: null,
    formErrors: {
      verifyAsFirstName: null,
      verifyAsLastName: null,
    },
  };

  componentDidMount() {
    const { labor, projLaborList, projContractorList, user } = this.props;
    const mergeWithLaborOptions = _.orderBy(
      projLaborList
        .filter((l) => l.isVerified)
        .map((l) => {
          const ctr = projContractorList.find((pc) => pc.contractorId === l.contractorId);
          return { value: l.laborId, label: `${l.fullName} (${ctr ? ctr.name : "N/A"})` };
        }),
      "label",
      "asc"
    );
    this.setState({
      verifyAsFirstName: labor.firstName,
      verifyAsMi: labor.middleInitial,
      verifyAsLastName: labor.lastName,
      mergeWithLaborOptions,
      verifiedOrMergedByUserId: user.userId,
    });
  }

  handleChange_textInput = (e) => this.setState({ [e.target.name]: e.target.value });

  handleChange_radio = (e) => {
    let verifyAs, mergeWith;
    if (e.target.name === "verifyAs") {
      verifyAs = true;
      mergeWith = false;
    }
    if (e.target.name === "mergeWith") {
      verifyAs = false;
      mergeWith = true;
    }
    this.setState({ verifyAs, mergeWith });
  };

  handleChange_select = (mergeWithLabor) => this.setState({ mergeWithLabor });

  handleClick_submit = (e) => {
    e.preventDefault();
    const { dispatch, toggleVerifyLaborModal, user } = this.props;
    const { verifyAsFirstName, verifyAsLastName, mergeWithLabor } = this.state;
    const labor = { ...this.props.labor };
    labor.firstName = verifyAsFirstName;
    labor.lastName = verifyAsLastName;
    labor.mergedWithLaborId = mergeWithLabor ? mergeWithLabor.value : null;
    labor.verifiedOrMergedByUserId = user.userId;

    dispatch(laborActions.verify(labor)).then(toggleVerifyLaborModal);
  };

  formIsIncomplete = () => {
    const {
      verifyAs,
      mergeWith,
      verifyAsFirstName,
      verifyAsLastName,
      mergeWithLabor,
      formErrors,
    } = this.state;
    if (
      verifyAs &&
      (!verifyAsFirstName ||
        !verifyAsLastName ||
        formErrors.verifyAsFirstName ||
        formErrors.verifyAsLastName)
    )
      return true;
    if (mergeWith && !mergeWithLabor) return true;
    return false;
  };

  render() {
    const {
      verifyAs,
      mergeWith,
      verifyAsFirstName,
      verifyAsMi,
      verifyAsLastName,
      formErrors,
      mergeWithLabor,
      mergeWithLaborOptions,
    } = this.state;
    const { showVerifyLaborModal, toggleVerifyLaborModal, fetching } = this.props;
    const closeBtn = (
      <button className="close" onClick={toggleVerifyLaborModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <Modal
        isOpen={showVerifyLaborModal}
        toggle={toggleVerifyLaborModal}
        className={this.props.className}
        size={"lg"}
        fade={false}
      >
        <ModalHeader
          toggle={toggleVerifyLaborModal}
          className="bg-info text-white"
          close={closeBtn}
        >
          <FontAwesomeIcon icon="user-check" className="fa-fw mr-2" />
          Verify Labor
        </ModalHeader>
        <ModalBody>
          <div className="alert alert-info p-2 w-100 mb-0">
            <h6>
              <FontAwesomeIcon icon="info-circle" className="fa-fw mr-2" />
              Labor Verification
            </h6>
            <ul className="mb-0">
              <li>
                You are verifying that the information below matches certified payrolls.
              </li>
              <li>
                Select "Merge With" if you are reconciling duplicate labor entries. The
                merge target can only be an existing verified labor, so if you don't see
                the desired merge target, you must first go back and verify the merge
                target.
              </li>
              <li>
                Once verified, this laborer will be accessible from all other projects
                where this laborer's contractor is listed. Verification is final - it
                cannot be undone. Any further changes after verification requires District
                ProDMS Administrator's review and authorization.
              </li>
            </ul>
          </div>
          <div className="card my-2 mx-0">
            <div className="card-body">
              <div className="form-row form-group mb-2 ml-6">
                <div className="col my-auto">
                  <div className="custom-control-inline custom-control custom-radio">
                    <input
                      type="radio"
                      name="verifyAs"
                      id="verifyAs"
                      className="custom-control-input my-auto"
                      checked={verifyAs}
                      onChange={this.handleChange_radio}
                    />
                    <label htmlFor="verifyAs" className="custom-control-label my-auto">
                      Verify Name As:
                    </label>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-row">
                <div style={{ width: "5%" }}></div>
                <div style={{ width: "40%", paddingRight: "0.2rem" }}>
                  <label htmlFor="verifyAsFirstName" className="form-label mb-0">
                    <b>First Name:</b>*
                  </label>
                  <input
                    type="text"
                    name="verifyAsFirstName"
                    id="verifyAsFirstName"
                    className="form-control"
                    value={verifyAsFirstName || ""}
                    onChange={this.handleChange_textInput}
                    disabled={!verifyAs}
                  />
                  {formErrors.verifyAsFirstName && (
                    <span className="error-small">
                      <small>{formErrors.verifyAsFirstName}</small>
                    </span>
                  )}
                </div>
                <div style={{ width: "10%", paddingRight: "0.2rem" }}>
                  <label htmlFor="verifyAsMi" className="form-label mb-0">
                    MI:
                  </label>
                  <input
                    type="text"
                    name="verifyAsMi"
                    id="verifyAsMi"
                    className="form-control"
                    value={verifyAsMi || ""}
                    onChange={this.handleChange_textInput}
                    disabled={!verifyAs}
                  />
                </div>
                <div style={{ width: "45%" }}>
                  <label htmlFor="verifyAsLastName" className="form-label mb-0">
                    <b>Last Name:</b>*
                  </label>
                  <input
                    type="text"
                    name="verifyAsLastName"
                    id="verifyAsLastName"
                    className="form-control"
                    value={verifyAsLastName || ""}
                    onChange={this.handleChange_textInput}
                    disabled={!verifyAs}
                  />
                  {formErrors.verifyAsLastName && (
                    <span className="error-small">
                      <small>{formErrors.verifyAsLastName}</small>
                    </span>
                  )}
                </div>
              </div>
              <div className="form-row form-group my-2 ml-6">
                <div className="col my-auto">
                  <div className="custom-control-inline custom-control custom-radio">
                    <input
                      type="radio"
                      name="mergeWith"
                      id="mergeWith"
                      className="custom-control-input my-auto"
                      checked={mergeWith}
                      onChange={this.handleChange_radio}
                    />
                    <label htmlFor="mergeWith" className="custom-control-label my-auto">
                      Merge With:
                    </label>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-row">
                <div style={{ width: "5%" }}></div>
                <div style={{ width: "70%" }}>
                  <Select
                    name="mergeWithLabor"
                    id="mergeWithLabor"
                    value={mergeWithLabor}
                    options={mergeWithLaborOptions}
                    onChange={this.handleChange_select}
                    isSearchable={true}
                    placeholder="Select Labor to Merge With"
                    isDisabled={!mergeWith}
                  />
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group mb-0">
            {fetching && (
              <span>
                <small>Saving...</small>
              </span>
            )}
            <button
              className="btn btn-primary mx-2"
              name="verifyLaborButton"
              id="verifyLaborButton"
              onClick={this.handleClick_submit}
              value="OK"
              disabled={this.formIsIncomplete() || fetching}
            >
              OK
            </button>
            <button
              className="btn btn-secondary"
              name="cancelVerifyLabor"
              id="cancelVerifyLabor"
              onClick={toggleVerifyLaborModal}
              disabled={fetching}
            >
              Cancel
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
  fetching:
    state.contractors.fetching || state.labors.fetching || state.contractors.fetching,
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
});

export default connect(mapStateToProps)(VerifyLaborModal);
